import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/pc/Index'
import Information from '@/components/pc/Information'
import InfoDetail from '@/components/pc/InfoDetail'
import Product from '@/components/pc/Product'
import CommingSoon from '@/components/pc/CommingSoon'

Vue.use(Router)

const originPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originPush.call(this, location).catch(err => err)
}
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/index',
      redirect: {
        name: 'Index'
      }
    },
    {
      path: '/index.html',
      redirect: {
        name: 'Index'
      }
    },
    {
      path: '/info',
      name: 'Information',
      component: Information
    },
    {
      path: '/info_detail',
      name: 'InfoDetail',
      component: InfoDetail
    },
    {
      path: '/product',
      name: 'Product',
      component: Product
    },
    {
      path: '/commingsoon',
      name: 'CommingSoon',
      component: CommingSoon
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js